module.exports = __webpack_public_path__ + "img/Asymmetrical Halo.26e2ac46.png";